import { render, staticRenderFns } from "./GroupDocuments.vue?vue&type=template&id=dc1408bc"
import script from "./GroupDocuments.vue?vue&type=script&lang=ts"
export * from "./GroupDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc1408bc')) {
      api.createRecord('dc1408bc', component.options)
    } else {
      api.reload('dc1408bc', component.options)
    }
    module.hot.accept("./GroupDocuments.vue?vue&type=template&id=dc1408bc", function () {
      api.rerender('dc1408bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupDocuments.vue"
export default component.exports